import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';

const PublishIntegration = ({
  handleAgent,
  updatePreviousVersion,
  versionHistory = [],
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [versions, setVersions] = useState([]);
  // Helper constto extract and parse Details JSON if present
  useEffect(() => {
    let lst = [];
    versionHistory.forEach((ver) => {
      const obj = JSON.parse(ver);
      lst.push({ date: obj.Date, details: JSON.parse(obj.Details) });
      console.log(lst);
    });
    setVersions(lst);
  }, [versionHistory]);

  const handleShowDetails = (ver) => {
    setSelectedVersion(ver?.details);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedVersion(null);
  };

  const handleAgentVersion = () => {
    updatePreviousVersion(selectedVersion);
    setModalOpen(false);
  }

  console.log(versionHistory, 'versionHistory');
  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h6>Publish your Voice Agent</h6>
        </div>
        <Separator className="mb-3" />
        <p>
          Publish will update or create your voice agent with the latest
          settings. Publish after making changes to your integration to ensure
          your agent is up to date.
        </p>

        <h6 className="my-2">Version History</h6>
        <ListGroup className="mb-3">
          {versionHistory.length === 0 ? (
            <ListGroupItem>No version history found.</ListGroupItem>
          ) : (
            versions.map((ver, idx) => (
              <ListGroupItem
                key={ver.id || idx}
                className="d-flex justify-content-between align-items-center"
              >
                <span>
                  <b className="d-flex mb-2">Version {ver.version || idx + 1}</b>
                  <span style={{ color: '#888' }}>
                    {ver.date
                      ? moment(ver.date).format('YYYY-MM-DD HH:mm:ss')
                      : ''}
                  </span>
                </span>
                <Button
                  color="info"
                  outline
                  size="xs"
                  onClick={() => handleShowDetails(ver)}
                >
                  View
                </Button>
              </ListGroupItem>
            ))
          )}
        </ListGroup>
        <Colxx className="text-center mb-3">
          <Button color="primary" size="xs" outline onClick={handleAgent}>
            Publish
          </Button>
        </Colxx>
        <Separator className="mb-3" />

        <Modal isOpen={modalOpen} toggle={closeModal} size="lg">
          <ModalHeader toggle={closeModal}>Version Details</ModalHeader>
          <ModalBody>
            {selectedVersion ? (
              <>
                <Colxx md="12">
                  {selectedVersion?.ConfigurationSettings && (
                    <div style={{ marginTop: 8 }}>
                      <b>Configuration Settings:</b>
                      <div style={{ marginLeft: 16, marginTop: 8 }}>
                        {console.log(
                          selectedVersion.ConfigurationSettings,
                          109
                        )}
                        {Object.entries(
                          selectedVersion.ConfigurationSettings
                        ).map(([key, value]) => (
                          <div key={key} style={{ marginBottom: 4 }}>
                            <b>{key}:</b>{' '}
                            <span style={{ wordWrap: 'break-word' }}>
                              {Array.isArray(value)
                                ? value.join(', ')
                                : typeof value === 'object' && value !== null
                                  ? JSON.stringify(value)
                                  : (value?.toString?.() ?? '')}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {selectedVersion?.Security && (
                    <div style={{ marginTop: 8 }}>
                      <b>Security:</b>

                      <div style={{ marginLeft: 16, marginTop: 8 }}>
                        {Object.entries(selectedVersion.Security).map(
                          ([key, value]) => (
                            <div key={key} style={{ marginBottom: 4 }}>
                              <b>{key}:</b>{' '}
                              <span>
                                {' '}
                                {Array.isArray(value)
                                  ? value.join(', ')
                                  : typeof value === 'object' && value !== null
                                    ? JSON.stringify(value)
                                    : (value?.toString?.() ?? '')}
                              </span>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  )}
                  {selectedVersion?.Features && (
                    <div style={{ marginTop: 8 }}>
                      <b>Features:</b>
                      <div style={{ marginLeft: 16, marginTop: 8 }}>
                        {Object.entries(selectedVersion.Features).map(
                          ([key, value]) => (
                            <Fragment>
                              {key === 'VoiceSettings' ? (
                                Object.entries((value)).map(
                                  ([key, value]) => (
                                    <div key={key} style={{ marginBottom: 4 }}>
                                      <b>Voice Detials:</b>{' '}
                                      <span style={{ wordWrap: 'break-word' }}>
                                        {Array.isArray(value)
                                          ? value.join(', ')
                                          : typeof value === 'object' &&
                                              value !== null
                                            ? JSON.stringify(value)
                                            : (value?.toString?.() ?? '')}
                                      </span>
                                    </div>
                                  )
                                )
                              ) : (
                                <div key={key} style={{ marginBottom: 4 }}>
                                  <b>{key}:</b>{' '}
                                  <span style={{ wordWrap: 'break-word' }}>
                                    {Array.isArray(value)
                                      ? value.join(', ')
                                      : typeof value === 'object' &&
                                          value !== null
                                        ? JSON.stringify(value)
                                        : (value?.toString?.() ?? '')}
                                  </span>
                                </div>
                              )}
                            </Fragment>
                          )
                        )}
                      </div>
                    </div>
                  )}
                </Colxx>
              </>
            ) : null}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" outline size="xs" onClick={handleAgentVersion}>
              Publish
            </Button>
            <Button color="secondary" outline size="xs" onClick={closeModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </CardBody>
    </Card>
  );
};

export default PublishIntegration;
